import React, { useEffect, useState } from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        width: '100%',
        borderRadius: '3px',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const FingerPrintIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <g>
                            <path
                                className={colorNonSelected}
                                d="M181,119.9c-1.3,0.9-32.5,22.7-39.7,64.7c-11.9,69.2-32.2,86.3-32.4,86.5c0.2-0.1,0.3-0.2,0.3-0.2l13.1,18.1
		c2.8-2,27.6-21.8,41.2-100.6c5.6-32.4,30.2-49.9,30.4-50.1c5.1-3.5,6.4-10.5,2.9-15.5C193,117.7,186.1,116.4,181,119.9L181,119.9z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M119.4,325.9c-5.4,2.9-7.5,9.7-4.5,15.1c2,3.8,5.9,5.9,9.9,5.9c1.8,0,3.6-0.4,5.3-1.3
		c2.2-1.2,54.6-29.9,64.6-88.3c8.5-49.1,23.6-81.2,43.7-92.9c11.4-6.6,24.7-6.9,40.6-1c5.8,2.1,12.2-0.8,14.4-6.6
		c2.1-5.8-0.8-12.2-6.6-14.4c-22.3-8.2-42.3-7.3-59.6,2.6c-26.5,15.3-44.8,51.8-54.6,108.4C164.4,300.7,120.1,325.4,119.4,325.9
		L119.4,325.9z"
                            />
                            <path
                                className={colorSelected}
                                d="M11.2,104.7c6.2,0,11.2-5,11.2-11.2V22.4h71.2c6.2,0,11.2-5,11.2-11.2S99.7,0,93.5,0H11.2C5,0,0,5,0,11.2v82.4
		C0,99.7,5,104.7,11.2,104.7L11.2,104.7z"
                            />
                            <path
                                className={colorSelected}
                                d="M417.1,22.4h71.2v71.2c0,6.2,5,11.2,11.2,11.2c6.2,0,11.2-5,11.2-11.2l0-82.4c0-6.2-5-11.2-11.2-11.2h-82.4
		c-6.2,0-11.2,5-11.2,11.2S410.9,22.4,417.1,22.4L417.1,22.4z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M313.2,106.8C288.8,94.3,262,86.7,234.7,84c-4.7-0.5-9.4-0.8-14.1-0.7c-14.4,0.3-14.4,22.7,0,22.4
		c4.1-0.1,8.2,0.2,12.2,0.6c2,0.2,4,0.4,6.1,0.6c0.4,0,0.8,0.1,1.1,0.1c1.4,0.2,2.8,0.4,4.2,0.6c5.9,1,11.7,2.2,17.5,3.6
		c6.8,1.7,13.6,3.8,20.2,6.2c1.7,0.6,3.4,1.3,5.1,1.9c0.9,0.3,1.7,0.7,2.6,1.1c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.2,0.1,0.4,0.1
		c3.9,1.7,7.7,3.5,11.5,5.4c7.8,4,15.3,8.5,22.4,13.5c1.8,1.3,3.6,2.6,5.4,3.9c0.7,0.5,2.1,1.6,3.9,3.1c3.9,3.2,7.6,6.6,11.3,10.1
		c14.3,13.9,25.1,29.1,34.5,46.9c2.8,5.4,10.2,7,15.3,4c5.4-3.2,6.8-9.9,4-15.3C379.5,155.9,349.9,125.7,313.2,106.8L313.2,106.8z"
                            />
                            <path
                                className={colorSelected}
                                d="M510.6,500.8v-82.4c0-6.2-5-11.2-11.2-11.2c-6.2,0-11.2,5-11.2,11.2v71.2h-71.2c-6.2,0-11.2,5-11.2,11.2
		s5,11.2,11.2,11.2h82.4C505.6,512,510.6,507,510.6,500.8L510.6,500.8z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M124.5,187c0-2,0.1-4,0.3-6c0-0.4,0.1-0.7,0.1-1c0,0,0,0,0,0c0.2-1.5,0.5-2.9,0.8-4.4c1.2-6.1,3-12.2,5-18.1
		c1.1-3.3,2.3-6.5,3.6-9.7c0.1-0.2,0.4-0.9,0.6-1.4c0.3-0.6,0.5-1.2,0.8-1.8c0.9-2,1.8-4,2.7-5.9c3.5-7.4,7.6-14.6,12-21.5
		c5.2-8.1,8.6-12.6,14.3-19.2c5.7-6.6,12.1-12.6,18.9-18.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.4-0.3,0.8-0.6
		c0.8-0.6,1.7-1.2,2.6-1.8c1.7-1.2,3.5-2.4,5.3-3.5c3.9-2.4,7.9-4.6,12-6.5c0.1,0,1.5-0.7,1.9-0.8c0.8-0.3,1.5-0.6,2.3-0.9
		c2-0.8,4-1.4,6.1-2.1c4.5-1.4,9.2-2.4,13.9-3.1c1.3-0.2,1.5-0.2,0.4,0c1.1-0.1,2.3-0.2,3.4-0.3c1.9-0.2,3.8-0.2,5.7-0.3
		c5.5-0.2,10.9-0.1,16.4,0.2c9.6,0.5,17.6,1.6,27,3.6c17.2,3.8,31.2,9.5,45.9,18.7c13.1,8.2,24.2,18.4,35,30.9
		c9.9,11.5,19.1,25.8,27.1,40.4c6.9,12.7,26.2,1.4,19.3-11.3c-19.1-35.1-45.4-67-81.4-85.7c-20.1-10.5-41.9-16-64.4-18.3
		c-21-2.1-42.5-1.2-62.3,6.7c-32.4,12.8-57.1,39.3-74.4,68.9c-7.5,12.9-13.7,26.8-18.3,41c-3.3,10.3-6.2,21.5-6,32.4
		C102.4,201.4,124.8,201.5,124.5,187L124.5,187z M124.8,180.3C124.6,182.3,124.7,181.1,124.8,180.3z"
                            />
                            <path
                                className={colorSelected}
                                d="M11.2,512h82.4c6.2,0,11.2-5,11.2-11.2c0-6.2-5-11.2-11.2-11.2H22.4v-71.2c0-6.2-5-11.2-11.2-11.2
		c-6.2,0-11.2,5-11.2,11.2v82.4C0,507,5,512,11.2,512L11.2,512z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M356.9,270.3c-11.4-6.7-22.6-13.8-33.5-21.3c-9.8-6.8-17.4-12.3-26.2-21.5c-9.9-10.5-25.7,5.4-15.8,15.8
		c17.5,18.5,40.6,32.2,62.3,45.2c13.8,8.3,27.9,16.2,42.3,23.6c5.4,2.8,12.1,1.5,15.3-4c3-5,1.4-12.5-4-15.3
		C383.5,285.7,370.1,278.1,356.9,270.3L356.9,270.3z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M333.6,195.4c-18.5-11.8-40.4-21.7-62.8-17.5c-18.5,3.5-32.7,20.2-38.2,37.5c-4.2,13.2-1.7,27,3.9,39.3
		c11.9,26.2,38.7,45.4,62.1,60.5c21.3,13.7,44.1,25.4,67.3,35.5c4.8,2.1,9.6,4.2,14.4,6.1c5.7,2.2,12.3-2.4,13.7-7.8
		c1.7-6.3-2.1-11.5-7.8-13.8c-1.1-0.4-2.2-0.9-3.3-1.3c-0.4-0.2-0.8-0.4-1.3-0.5c0,0,0,0-0.1,0c-1.8-0.8-3.6-1.5-5.4-2.3
		c-10.2-4.5-20.3-9.3-30.2-14.4c-12.9-6.6-25.5-13.8-37.7-21.7c-6.1-4-12.1-8.2-18-12.6c-0.1-0.1-2.7-2.1-3.2-2.5
		c-1.4-1.1-2.7-2.2-4.1-3.4c-2.8-2.4-5.6-4.9-8.3-7.5c-2.4-2.3-4.7-4.7-6.9-7.2c-1.1-1.2-2.1-2.4-3.1-3.7c-0.2-0.3-0.4-0.6-0.7-0.8
		c0,0-1.1-1.5-1.4-1.8c-1.7-2.4-3.3-4.9-4.8-7.5c-0.7-1.3-1.3-2.5-2-3.8c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.6-1.5-0.8-1.9
		c-0.9-2.5-1.6-5.1-2.1-7.8c0,0,0,0,0,0c-0.1-0.5-0.1-1.1-0.1-1.6c-0.1-1.5-0.1-3.1,0-4.6c0-0.5,0.1-1,0.1-1.5c0-0.1,0-0.1,0-0.2
		c0.2-1.3,0.6-2.7,0.9-4c0.3-1,0.6-2,1-3c-0.3,0.8,1.4-2.8,1.8-3.5c2.1-3.8,3.7-5.8,6.5-8.7c0.8-0.8,1.7-1.6,2.5-2.3
		c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.4-0.2,0.9-0.6c0.9-0.6,1.8-1.1,2.7-1.6c0.6-0.3,1.2-0.6,1.8-0.9c0.1,0,0.2-0.1,0.3-0.1
		c7.6-2.9,14.4-2.1,22.9,0.3c21.7,6.2,42.3,22.8,59.9,37.8c9.6,8.2,18.8,16.7,28,25.4c10.4,9.9,26.3-5.9,15.8-15.8
		C378.1,229.4,357.2,210.5,333.6,195.4L333.6,195.4z M252.9,226.4C252.7,228.4,252.8,227.3,252.9,226.4z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M263.4,456.3c1.2,0.9,2.2,1.9,3.3,2.9c1.8,1.6,3.6,3.3,5.3,5c3.7,3.7,7.3,7.5,10.6,11.6c3.8,4.7,11.8,4,15.8,0
		c4.6-4.6,3.8-11.1,0-15.8c-10.8-13.3-24.3-25.8-40.2-32.4c-11.6-4.8-24.4-1.3-33.2,7.1c-9.1,8.7-12.4,18.9-22.9,25.6
		c-12.1,7.7-0.9,27.1,11.3,19.3c10.5-6.7,17.1-16.1,24.4-25.8c-1.3,1.7,0.8-1,0.9-1.1c0.6-0.8,1.4-1.5,2.1-2.2
		c0.1-0.1,0.9-0.8,1.3-1.1c0.8-0.4,2.1-1.1,1.8-1.1c0.6-0.2,1.2-0.3,1.8-0.4c-0.6,0.2,0.9,0.1,1.9,0c0.4,0,0.9,0.1,1.1,0.2
		c1,0.2,1.9,0.6,2.8,0.9c-0.8-0.3,1.4,0.7,1.6,0.8c0.9,0.5,1.8,1,2.7,1.5c2,1.2,3.9,2.5,5.8,3.9
		C261.3,454.6,263.4,456.3,263.4,456.3L263.4,456.3z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M321.5,437.8c10.1,10.3,25.9-5.5,15.8-15.8c-6.7-6.8-14-13.2-21.3-19.3c-14.3-11.9-29.7-23.3-46.9-30.9
		c-17.5-7.7-38.7-11.3-55.5,0.2c-7.7,5.2-13.1,12.7-18.1,20.4c-5.6,8.5-9.6,14.8-16.6,21.8c-3.9,3.9-8.2,7.1-12.8,10
		c-12.2,7.7-1,27,11.3,19.3c10.7-6.7,19.7-15.1,27.4-25.2c5.2-6.8,9.4-14.2,14.5-21.1c0,0,1-1.3,1.2-1.5c0.6-0.7,1.2-1.4,1.9-2
		c0.6-0.6,1.3-1.3,2-1.9c0.2-0.2,0.3-0.3,0.4-0.4c0.1,0,0.1-0.1,0.2-0.1c1.3-0.9,2.7-1.7,4.2-2.4c-0.7,0.4,1.5-0.5,1.8-0.6
		c1.4-0.4,2.8-0.7,4.2-1c0.9-0.2,2.7-0.3,5.2-0.3c0.8,0,4.6,0.4,4,0.2c3.9,0.6,7.8,1.8,11.5,3.1c0.8,0.3,1.5,0.6,2.3,0.9
		c-0.5-0.2,1.7,0.8,1.9,0.8c2,0.9,3.9,1.9,5.8,2.9c4.3,2.2,8.4,4.7,12.5,7.4c8.1,5.2,14.2,9.8,20.5,15
		C306.6,423.7,314.3,430.5,321.5,437.8C321.5,437.8,321.5,437.8,321.5,437.8L321.5,437.8z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M381.2,391c2.8-4.7,1.6-12.9-4-15.3c-26.9-11.4-53.3-24.2-78.9-38.1c-9.5-5.2-18.8-10.6-28-16.3
		c-7.9-5-15.3-11.5-23.9-15.5c-17.3-8.1-33.9-3-47.9,8.9c-10.5,8.9-18.6,20.5-27.2,31.2c-4.4,5.5-8.8,10.8-13.7,15.9
		c-2.3,2.4-4.7,4.6-7.3,6.8c-0.3,0.2-0.6,0.4-0.8,0.7c0.5-0.4-1.2,0.9-1.5,1.1c-1.5,1.1-3.1,2-4.7,2.9c-12.5,7.1-1.3,26.4,11.3,19.3
		c15.3-8.7,26.4-23,37.1-36.6c5.3-6.7,10.6-13.4,16.5-19.6c2.4-2.5,4.9-4.9,7.6-7.1c-0.5,0.5,2.6-1.7,3.2-2.1
		c0.7-0.4,1.4-0.8,2.1-1.2c0.3-0.2,1.6-0.7,2-0.9c1.1-0.4,2.3-0.7,3.5-1c0.1,0,0.2,0,0.2,0c0.7-0.1,1.5-0.1,2.3-0.1c0.3,0,0.7,0,1,0
		c0.2,0,1.3,0.2,1.7,0.3c0.8,0.2,1.7,0.4,2.5,0.7c0.4,0.1,0.9,0.3,1.3,0.5c0.1,0,0.2,0.1,0.3,0.2c8.5,4,16.1,10.7,24,15.7
		c18.2,11.5,37.4,21.5,56.6,31c16.2,8,32.6,15.7,49.2,22.8C371.5,397.4,377.8,396.8,381.2,391L381.2,391z"
                            />
                        </g>
                    </svg>
                </p>
                <h6>{props.name}</h6>
            </div>
        </>
    );
};

export default FingerPrintIcon;
